import { render, staticRenderFns } from "./ExpenseAndPoSpend.vue?vue&type=template&id=1068364c"
import script from "./ExpenseAndPoSpend.vue?vue&type=script&lang=js"
export * from "./ExpenseAndPoSpend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports